import { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Core pages - imported directly for fast initial load
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/layout/Layout";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";


// Auth pages - lazy loaded
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const OAuthCallback = lazy(() => import("./pages/OAuthCallback"));
const EmailVerified = lazy(() => import("./pages/EmailVerified"));
const SignupStep1 = lazy(() => import("./pages/signup/Step1"));
const SignupStep2 = lazy(() => import("./pages/signup/Step2"));
const SignupStep3 = lazy(() => import("./pages/signup/Step3"));
const SignupStep4 = lazy(() => import("./pages/signup/Step4"));

// Dashboard pages - lazy loaded
const WidgetIntegration = lazy(() => import("./pages/WidgetIntegration"));
const WidgetSettings = lazy(() => import("./pages/WidgetSettings"));
//const Pages = lazy(() => import("./pages/Pages"));
//const UnreachablePages = lazy(() => import("./pages/UnreachablePages"));
//const Documents = lazy(() => import("./pages/Documents"));
//const AutomatedTests = lazy(() => import("./pages/AutomatedTests"));
const ManagePlan = lazy(() => import("./pages/ManagePlan"));
const Settings = lazy(() => import("./pages/Settings"));

// Simple loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
  </div>
);

export default function App() {
  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Auth Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/oauth/callback" element={<OAuthCallback />} />
          <Route path="/email-verified" element={<EmailVerified />} />

          <Route path="/signup/step1" element={<SignupStep1 />} />
          <Route path="/signup/step2" element={<SignupStep2 />} />
          <Route path="/signup/step3" element={<SignupStep3 />} />
          <Route path="/signup/step4" element={<SignupStep4 />} />

          {/* Payment Routes */}
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />

          {/* Protected Routes with Layout */}
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/:websiteId" element={<Dashboard />} />
            <Route path="/manage-plan/:websiteId" element={<ManagePlan />} />
            <Route path="/widget-integration/:websiteId" element={<WidgetIntegration />} />
            <Route path="/widget-settings/:websiteId" element={<WidgetSettings />} />
            {/* <Route path="/pages" element={<Pages />} />
            <Route path="/unreachable-pages" element={<UnreachablePages />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/automated-tests" element={<AutomatedTests />} /> */}
            <Route path="/manage-plan" element={<ManagePlan />} />
            <Route path="/settings" element={<Settings />} />
          </Route>

          {/* Default route */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
      <Toaster richColors />
    </Router>
  );
}
